import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Invoices_ShellService } from './Invoices.shell.service';
import { Invoices_OperationService } from './Invoices.operation.service';
import { Invoices_DatasourceService } from './Invoices.datasource.index';
import { Invoices_FlowService } from './Invoices.flow.index';
import { Invoices_ReportService } from './Invoices.report.index';
import { Invoices_LocalizationService } from './Invoices.localization.service';
import { Invoices_billingcodes_dd_ComponentContextService } from './Invoices.billingcodes_dd.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Invoices.frontend.types'
import { $frontendTypes as $types} from './Invoices.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'Invoices-billingcodes_dd_single',
  templateUrl: './Invoices.billingcodes_dd_single.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Invoices_billingcodes_dd_singleComponent),
      multi: true
    }
  ]
})
export class Invoices_billingcodes_dd_singleComponent extends BaseComponent implements OnInit, ControlValueAccessor {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;
  
  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return false;
  }

  get isSingle() {
    return true;
  }



  fullTextSearch: string;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Invoices_ShellService,
    private $datasources: Invoices_DatasourceService,
    private $flows: Invoices_FlowService,
    private $reports: Invoices_ReportService,
    private $localization: Invoices_LocalizationService,
    private $operations: Invoices_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Invoices_billingcodes_dd_ComponentContextService,
    private _elementRef: ElementRef
    ) {
    super();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  
  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): number | number[] {
    return this._innerValue;
  }

  set value(val: number | number[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }



  displayWithFn(value: any): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = null;
      const $fullTextSearch = null;
      this.$datasources.Invoices.ds_billingcodes_dd.getByKeys({
        $keys: [value],
        fullTextSearch:  $selector.fullTextSearch ,
      }).then(result => {
        const found = result.result[0];
        const e: { Id?: number, Description?: string, Name?: string } = found ?? {};
        const $option = { entity: e };
         const $entity = e;
        const displayTextResult = found ? ($option.entity.Name + ' ' + $option.entity.Description) : 'No data to display';
        this.displayTextChange.emit(displayTextResult);
        resolve(displayTextResult);
      });

    });
    return promise;
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {

    const promise = new Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = filterText;
      const $fullTextSearch = filterText;
      this.$datasources.Invoices.ds_billingcodes_dd.getList({
        $top: 50,
        $skip: 0,
        fullTextSearch:  $selector.fullTextSearch ,
      }).then(result => {
        resolve({
          list: result.result.map(item => {
            const $option = { entity: item };
            const $entity = item;
            const $resultOption = { key: null, name: $option.entity.Name + ' ' + $option.entity.Description, disabled: null };
            $resultOption.key = $option.entity.Id;
            return $resultOption;
          }),
          totalCount: result.totalCount,
          top: 50
        });
      });

    });

    return promise;

  }

}
